<template>
  <div>
    <base-modal v-model="showResult" title="Результаты теста" :icon="'test-result'">
      <test-question-result :questions="questions" />
    </base-modal>
    <div class="fill-grey company-stat-list mt-24" v-for="item in items" :key="item.id">
      <div class="company-stat-list__title">
        <strong>{{ item.person.fullname }}</strong><br/>
        {{ item.person.organization.name }}
      </div>
      <div class="company-stat-list__text">
        <div class="d-flex align-items-center">
          {{ getStatus(item) }}
        </div>
      </div>
      <div class="company-stat-list__mark">
        <div class="d-flex align-items-center">
          <div>
            <div class="text-blue-03">
              0/<sub>28</sub>
            </div>
            <a @click.prevent="showTestResult(item.control_questions)" href="#">Итоговый тест</a>
          </div>
        </div>
      </div>
      <div class="company-stat-list__text" v-if="item.cert">
        <div class="d-flex align-items-center">
          <div>
            <a :href="apiUrl + 'certificates/' + item.cert.id" target="_blank">Скачать</a>
            <div>
              <a href="#">сертификат</a>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mb-1 ml-1">
                <rect width="24" height="24" rx="12" fill="#ED1B2F"/>
                <path d="M17.9199 6.62C17.8185 6.37565 17.6243 6.18147 17.3799 6.08C17.2597 6.02876 17.1306 6.00158 16.9999 6H6.99994C6.73472 6 6.48037 6.10536 6.29283 6.29289C6.1053 6.48043 5.99994 6.73478 5.99994 7C5.99994 7.26522 6.1053 7.51957 6.29283 7.70711C6.48037 7.89464 6.73472 8 6.99994 8H14.5899L6.28994 16.29C6.19621 16.383 6.12182 16.4936 6.07105 16.6154C6.02028 16.7373 5.99414 16.868 5.99414 17C5.99414 17.132 6.02028 17.2627 6.07105 17.3846C6.12182 17.5064 6.19621 17.617 6.28994 17.71C6.3829 17.8037 6.4935 17.8781 6.61536 17.9289C6.73722 17.9797 6.86793 18.0058 6.99994 18.0058C7.13195 18.0058 7.26266 17.9797 7.38452 17.9289C7.50638 17.8781 7.61698 17.8037 7.70994 17.71L15.9999 9.41V17C15.9999 17.2652 16.1053 17.5196 16.2928 17.7071C16.4804 17.8946 16.7347 18 16.9999 18C17.2652 18 17.5195 17.8946 17.707 17.7071C17.8946 17.5196 17.9999 17.2652 17.9999 17V7C17.9984 6.86932 17.9712 6.74022 17.9199 6.62Z" fill="white"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseModal from "@/components/modal/BaseModal.vue";
import TestQuestionResult from "@/components/profile/test/TestQuestionResult.vue";

export default {
  name: "SeminarCompanyStatList",
  components: {TestQuestionResult, BaseModal},
  props: {
    items: {
      type: Array,
      require: true
    }
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_ROOT_API,
      showResult: false,
      questions: []
    }
  },
  methods: {
    getStatus(row) {
      switch (row.status) {
        case 'approved':
          return row.cert ? 'Получил сертификат' : 'Принят'
        case 'rejected':
          return 'Отклонен';
        case 'draft':
          return 'Черновик';
      }
    },
    showTestResult(questions) {
      this.showResult = true
      this.questions = questions
      return false;
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss">
@import "@/../src/assets/style/variables.scss";
.company-stat-list {
  display: flex;
  flex-flow: wrap;
  padding: 3.6rem 0;
  &__title {
    width: 30%;
    flex: 0 0 30%;
    padding: 0 2.4rem;
    line-height: 2.4rem;
    font-size: 1.8rem;
  }
  &__mark, &__text {
    flex-grow: 1;
    border-left: 2px solid #BDBDBD;
    padding: 0 2.4rem;
    color: $grey-02;
    a {
      font-size: 1.8rem;
      font-style: normal;
      font-weight: 400;
      line-height: 2.4rem; /* 133.333% */
      color: $blue-0;
      text-decoration: underline;
    }
    .d-flex {
      height: 100%;
    }
  }
  &__mark {
    font-size: 3.2rem;
    font-style: normal;
    font-weight: 400;
    line-height: 3.6rem;
    sub {
      font-size: 1.8rem;
      font-style: normal;
      font-weight: 700;
      line-height: 2.4rem;
    }
  }
}
</style>